import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, MessageCircle, User, Plus, Gift } from 'lucide-react';

/**
 * Bottom tab bar for phones. The center "create" action is deliberately
 * prominent; everything else mirrors the sidebar's primary destinations.
 */
const MobileTabBar: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  const tabClass = (active: boolean) =>
    `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-semibold transition-colors ${
      active ? 'text-accent-blue' : 'text-text-muted hover:text-text-primary'
    }`;

  return (
    <nav
      aria-label="Primary"
      className="glass fixed inset-x-3 bottom-3 z-40 flex items-stretch rounded-2xl lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <Link to="/" className={tabClass(isActive('/'))}>
        <Home className="h-5 w-5" />
        Home
      </Link>
      <Link to="/events" className={tabClass(isActive('/events'))}>
        <Calendar className="h-5 w-5" />
        Events
      </Link>
      <Link to="/cultural-posts" className="flex flex-1 items-center justify-center" aria-label="Create post">
        <span className="grid h-11 w-11 -translate-y-3 place-items-center rounded-full bg-brand-gradient text-white shadow-glow-blue transition-transform duration-200 ease-spring active:scale-95">
          <Plus className="h-5 w-5" />
        </span>
      </Link>
      <Link to="/messages" className={tabClass(isActive('/messages'))}>
        <MessageCircle className="h-5 w-5" />
        Messages
      </Link>
      <Link to="/profile" className={tabClass(isActive('/profile'))}>
        <User className="h-5 w-5" />
        Profile
      </Link>
      <Link to="/earn-rewards" className={tabClass(isActive('/earn-rewards'))}>
        <Gift className="h-5 w-5" />
        Rewards
      </Link>
    </nav>
  );
};

export default MobileTabBar;
